// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { compose } from 'recompose';
import moment from 'moment';

import Widget02 from 'views/Widgets/Widget02';

import { loadLogs } from 'actions/logs';
import type { Log as LogType } from 'actions/logs';

type Props = {
  // redux
  logs: Array<LogType>,
  onLoadLogs: typeof loadLogs,
};

const TYPE_MAPPING = {
  login: {
    header: 'Letzter Login',
    icon: 'icon-login',
    color: 'secondary',
    variant: '1',
  },
  like: {
    header: 'Unterstützung erhalten',
    icon: 'icon-heart',
    color: 'success',
    variant: '1',
  },
  comment: {
    header: 'Kommentar hinterlassen',
    icon: 'icon-bubble',
    color: 'primary',
    variant: '1',
  },
  report: {
    header: 'Meldung erstellt',
    icon: 'icon-note',
    color: 'danger',
    variant: '1',
  },
};

class Log extends React.Component<Props> {
  componentDidMount() {
    this.props.onLoadLogs();
  }

  render() {
    const { logs } = this.props;

    return (
      <div className="animated fadeIn">
        {logs.map(log => {
          const coreComponent = (
            <Widget02
              mainText={moment(log.createdAt).format('DD. MMMM YYYY - HH:mm')}
              key={`${log.createdAt}`}
              {...TYPE_MAPPING[log.type]}
            />
          );

          if (log.reportId) {
            return (
              <Link
                key={`${log.createdAt}`}
                to={`/report/${log.reportId}`}
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
                {coreComponent}
              </Link>
            );
          }
          return coreComponent;
        })}
      </div>
    );
  }
}

const mapStateToProps = ({ logs }) => ({
  logs,
});
const mapDispatchToProps = dispatch => ({
  onLoadLogs: (...args) => dispatch(loadLogs(...args)),
});

const LogContainer = compose(connect(mapStateToProps, mapDispatchToProps))(Log);

export default LogContainer;



// WEBPACK FOOTER //
// ./src/views/Log/Log.js